export default __webpack_public_path__ + "static/media/login-bg-15.98456fea.jpg";